import zhCN from './zh-CN'
import enUS from './en-US'
import arAE from './ar-AE'
import deDE from './de-DE'
import esES from './es-ES'
import frFR from './fr-FR'
import jaJP from './ja-JP'
import koKR from './ko-KR'
import ptBR from './pt-BR'
import ruRU from './ru-RU'

export const messages = {
  'zh-CN': zhCN,
  'en-US': enUS,
  'ar-AE': arAE,
  'de-DE': deDE,
  'es-ES': esES,
  'fr-FR': frFR,
  'ja-JP': jaJP,
  'ko-KR': koKR,
  'pt-BR': ptBR,
  'ru-RU': ruRU
}

export const defaultLocale = 'en-US'

export const availableLocales = [
  { code: 'zh-CN', name: '简体中文' },
  { code: 'en-US', name: 'English' },
  { code: 'ar-AE', name: 'العربية' },
  { code: 'de-DE', name: 'Deutsch' },
  { code: 'es-ES', name: 'Español' },
  { code: 'fr-FR', name: 'Français' },
  { code: 'ja-JP', name: '日本語' },
  { code: 'ko-KR', name: '한국어' },
  { code: 'pt-BR', name: 'Português' },
  { code: 'ru-RU', name: 'Русский' }
]
